<template>
  <div class="max-h-[calc(70vh-120px)]">
    <form @submit.prevent="submitForm" class="space-y-4">
      <div class="grid grid-cols-2 gap-x-20 gap-y-6 px-20">
        <div>
          <label for="code" class="block text-sm font-medium text-gray-700"
            >Code<span class="text-red-500">*</span></label
          >
          <input
            type="text"
            id="code"
            v-model="form.code"
            placeholder="Type... "
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          />
          <span class="text-sm text-red-500" v-if="this.errors.code">
            Code is required
          </span>
        </div>
        <div>
          <label
            for="storageConditions"
            class="block text-sm font-medium text-gray-700"
            >Medicine Type<span class="text-red-500">*</span></label
          >
          <select
            id="storageConditions"
            v-model="form.drug_category_id"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          >
            <option
              v-for="category of drugCategories"
              :key="category.id"
              :value="category.id"
            >
              {{ category.name }}
            </option>
          </select>
          <span
            class="text-sm text-red-500"
            v-if="this.errors.drug_category_id"
          >
            Medicine type is required
          </span>
        </div>

        <div>
          <label
            for="genericName"
            class="block text-sm font-medium text-gray-700"
            >Generic Name<span class="text-red-500">*</span></label
          >
          <input
            type="text"
            id="genericName"
            v-model="form.generic_name"
            placeholder="Type... (eg. DICLOFENAC SODIUM)"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          />
          <span class="text-sm text-red-500" v-if="this.errors.generic_name">
            Generic name is required
          </span>
        </div>
        <div>
          <label for="brandName" class="block text-sm font-medium text-gray-700"
            >Brand Name<span class="text-red-500">*</span></label
          >
          <input
            type="text"
            id="brandName"
            v-model="form.trade_name"
            placeholder="Type... (eg. DICLOFENAC SODIUM)"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          />
          <span class="text-sm text-red-500" v-if="this.errors.generic_name">
            Brand name is required
          </span>
        </div>
        <div>
          <label
            for="storageConditions"
            class="block text-sm font-medium text-gray-700"
            >Storage Conditions<span class="text-red-500">*</span></label
          >
          <select
            id="storageConditions"
            v-model="form.storage_conditions"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          >
            <option
              v-for="storage of storageConditions"
              :key="storage.id"
              :value="storage.label"
            >
              {{ storage.label }}
            </option>
          </select>
          <span
            class="text-sm text-red-500"
            v-if="this.errors.storage_conditions"
          >
            Storage condition is required
          </span>
        </div>
        <div>
          <label
            for="formulationType"
            class="block text-sm font-medium text-gray-700"
            >Formulation Type <span class="text-red-500">*</span></label
          >
          <select
            id="formulationType"
            v-model="form.drug_dosage_form_id"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          >
            <option
              v-for="dosageForm of druDosageForms"
              :key="dosageForm.id"
              :value="dosageForm.id"
            >
              {{ dosageForm.name }}
            </option>
          </select>

          <span
            class="text-sm text-red-500"
            v-if="this.errors.drug_dosage_form_id"
          >
            Formulation type is required
          </span>
        </div>
        <div>
          <label
            for="dosageStrength"
            class="block text-sm font-medium text-gray-700"
            >Dosage Strength<span class="text-red-500">*</span></label
          >
          <input
            type="number"
            id="dosageStrength"
            v-model="form.strength"
            placeholder="Type... (e.g 500)"
            step="any"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          />

          <span class="text-sm text-red-500" v-if="this.errors.strength">
            Strength is required
          </span>
        </div>
        <div>
          <label
            for="unitOfMeasure"
            class="block text-sm font-medium text-gray-700"
            >Unit of Measure<span class="text-red-500">*</span></label
          >

          <select
            id="formulationType"
            v-model="form.drug_strength_unit_id"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          >
            <option
              v-for="unit of drugUnitStrengths"
              :key="unit.id"
              :value="unit.id"
            >
              {{ unit.name }}
            </option>
          </select>

          <span
            class="text-sm text-red-500"
            v-if="this.errors.drug_strength_unit_id"
          >
            Strength unit is required
          </span>
        </div>
        <div>
          <label
            for="requiresPrescription"
            class="block text-sm font-medium text-gray-700"
            >Requires Prescription <span class="text-red-500">*</span></label
          >
          <select
            id="requiresPrescription"
            v-model="form.prescription_required"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>

        <div>
          <label for="approvalRequired" class="block text-sm font-medium text-gray-700">
            Requires Doctor Approval
          </label>
          <select
            id="approvalRequired"
            v-model="form.approval_required"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          >
            <option value="false">No — can be prescribed at registration / OTC</option>
            <option value="true">Yes — doctor must order from consultation</option>
          </select>
        </div>

        <!-- <div>
          <label
            for="hospitalLocation"
            class="block text-sm font-medium text-gray-700"
            >Location in the hospital <span class="text-red-500">*</span></label
          >
          <select
            id="hospitalLocation"
            v-model="form.location"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          >
            <option value="Normal/Refrigerated">
              Select Location(e.g triage)
            </option>
          </select>
        </div> -->

        <div>
          <label for="ndc" class="block text-sm font-medium text-gray-700"
            >National Drug Code (NDC)</label
          >
          <input
            type="text"
            id="ndc"
            v-model="form.ndc"
            placeholder="Type..."
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          />
        </div>

        <div>
          <label
            for="manufacturer"
            class="block text-sm font-medium text-gray-700"
            >Manufacturer</label
          >
          <input
            type="text"
            id="manufacturer"
            v-model="form.manufacturer"
            placeholder="Type..."
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-custom-yellow focus:ring focus:ring-custom-yellow focus:ring-opacity-50 bg-gray-50"
          />
        </div>

        <div class="flex justify-end mt-6 gap-y-6 px-20">
          <button
            type="submit"
            class="px-4 py-2 bg-custom-yellow text-white rounded-md hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-custom-yellow focus:ring-opacity-50"
          >
            <span v-if="!showLoader"> Submit </span>
            <span v-else>
              <svg
                class="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                  fill="none"
                />
              </svg>
            </span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import apiClient from "@/services/api";

export default {
  name: "PharmaceuticalFormTab",
  data() {
    return {
      form: {
        item_type: 1,
        code: "",
        drug_category_id: "",
        generic_name: "",
        trade_name: "",
        drug_dosage_form_id: "",
        strength: "",
        drug_strength_unit_id: "",
        manufacturer: "",
        storage_conditions: "",
        unit_price: "",
        location: "",
        ndc: "",
        prescription_required: "",
        approval_required: "false",
      },
      submitStatus: null,
      showLoader: false,
      errors: {},
      drugCategories: [],
      drugUnitStrengths: [],
      druDosageForms: [],
      storageConditions: [
        { id: 1, label: "Normal" },
        { id: 2, label: "Refrigarated" },
      ],
    };
  },
  mounted() {
    this.fetchIventoryCreationData();
  },
  methods: {
    async submitForm() {
      if (!this.validateForm()) {
        return;
      }
      try {
        this.showLoader = true;
        const response = await apiClient.createInventoryItem(this.form);
        if (response.success) {
          this.showLoader = false;
          this.$toast.success("Inventory Item created successfully");
          this.$router.push("/inventory");
        } else {
          this.showLoader = false;
          this.$toast.error(response.message);
        }
      } catch (error) {
        this.showLoader = false;
        this.$toast.error("Failed to create inventory item");
        console.log(error);
      }
    },
    async fetchIventoryCreationData() {
      try {
        this.showLoader = true;
        const response = await apiClient.fetchInventorycreationData();
        if (response.success) {
          this.showLoader = false;
          this.drugCategories = response.data?.drug_categories;
          this.drugUnitStrengths = response.data?.drug_unit_strengths;
          this.druDosageForms = response.data?.drug_dosage_forms;
        }
      } catch (error) {
        this.showLoader = false;
        this.$toast.error("Failed to unable to fetch inventory items");
        console.log(error);
      }
    },
    resetForm() {
      // Reset all form fields to their initial values
      Object.keys(this.form).forEach((key) => {
        this.form[key] = "";
      });
      this.form.category = "Pharmaceutical";
      this.form.storageConditions = "Normal/Refrigerated";
      this.form.location = "Triage/Consultation/Pharmacy";
    },
    validateForm() {
      this.errors = {};
      let count = 0;

      const fields = [
        "code",
        "drug_category_id",
        "generic_name",
        "trade_name",
        "drug_dosage_form_id",
        "strength",
        "drug_strength_unit_id",
        "storage_conditions",
      ];

      fields.forEach((field) => {
        if (!this.form[field]) {
          count = count + 1;
          this.errors[field] = true;
        }
      });

      if (count > 0) {
        return false;
      }

      return true;
    },
    camelToTitleCase(camelCaseStr) {
      // Insert a space before each uppercase letter and convert the string to an array of words
      const words = camelCaseStr.replace(/([A-Z])/g, " $1").split(" ");

      // Capitalize the first letter of each word and join them with a space
      const titleCaseStr = words
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      return titleCaseStr;
    },
  },
};
</script>
